<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :sortBy="sortBy"
      :showFields="showFields"
      :displayHideFields="displayHideFields"
      :pageMode="true"
      :showExpand="false"
      :rowClickRead="true"
      :filterSelects="filterSelects"
      :filterProps="filterProps"
      @filter-select="$_onFilterSelect($event)"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/license_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "sequence",
      "name",
      "areas",
      "license_type",
      "updated_at",
      "updated_admin",
    ],
    liveSearching: true,
    sortBy: "sequence",
    displayHideFields: ["acts"],
    filterSelects: [
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "area",
        placeholder: "請選擇地區",
      },
      {
        type: "belongsTo",
        label: "",
        modelName: "license_type",
        placeholder: "請選擇證照類型",
      },
      {
        type: "switch-tabs",
        label: "",
        textKey: "name",
        modelName: "status",
        defaultValue: "1",
        width: "72px",
        items: [
          {
            value: "1",
            text: "顯示",
          },
          {
            value: "0",
            text: "隱藏",
          },
          {
            value: "2",
            text: "修訂中",
          },
        ],
      },
      {
        type: "select",
        label: "",
        modelName: "range_type",
        placeholder: "篩選適用範圍類型",
        textKey: "name",
        items: [
          {
            text: "所有類型",
            value: "",
          },
          {
            text: "通用",
            value: "general",
          },
          {
            text: "專屬",
            value: "exclusive",
          },
        ],
        defaultValue: "",
      },
      {
        type: "hasMany",
        label: "",
        modelName: "factory",
        paramName: "exclusive_factories",
        placeholder: "篩選專屬工廠",
        textKey: "name",
        getText(item) {
          return this.$_CMS_getFactoryName(item)
        },
      },
      {
        type: "hasMany",
        label: "",
        modelName: "factory",
        paramName: "factories",
        placeholder: "篩選適用工廠",
        textKey: "name",
        getText(item) {
          return this.$_CMS_getFactoryName(item)
        },
      },
    ],
    filterProps: {},
  }),
  methods: {
    $_onFilterSelect($event) {
      if ($event && ($event.exclusive_factories || $event.factories)) {
        if (this.filterProps.range_type != $event.range_type) {
          if ($event.range_type === "exclusive") {
            this.filterProps = {
              ...$event,
              factories: null,
            };
          } else if ($event.range_type === "general") {
            this.filterProps = {
              ...$event,
              exclusive_factories: null,
            };
          } else if ($event.range_type === "") {
            this.filterProps = {
              ...$event,
              factories: null,
              exclusive_factories: null,
            };
          }
        } else {
          this.filterProps = {
            ...$event,
          };
        }
      } else {
        this.filterProps = {
            ...$event,
          };
      }
    },
  },
};
</script>

<style>
</style>